import { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { OnboardingFlow } from './components/onboarding';
import { TransactionsPage } from './pages/TransactionsPage';
import { ImportPage } from './pages/ImportPage';
import { BudgetPage } from './pages/BudgetPage';
import { ChartDemoPage } from './pages/ChartDemoPage';
import { SettingsPage } from './pages/SettingsPage';
import { ReportesPage } from './pages/ReportesPage';
import { ToastProvider } from './components/ui/Toast';
import { useOnboarding } from './hooks/useOnboarding';
import { useAppStore } from './store';

function HomeRedirect() {
  const transactions = useAppStore((state) => state.transactions);
  const hasTransactions = transactions.length > 0;
  return (
    <Navigate to={hasTransactions ? '/transacciones' : '/importar'} replace />
  );
}

function AppContent() {
  const { isFirstTimeUser, isInitialized } = useOnboarding();
  const [showOnboarding, setShowOnboarding] = useState<boolean | null>(null);
  const loadFromStorage = useAppStore((state) => state.loadFromStorage);

  useEffect(() => {
    loadFromStorage();
  }, [loadFromStorage]);

  useEffect(() => {
    if (isInitialized && showOnboarding === null) {
      setShowOnboarding(isFirstTimeUser);
    }
  }, [isInitialized, isFirstTimeUser, showOnboarding]);

  const handleOnboardingComplete = useCallback(() => {
    setShowOnboarding(false);
  }, []);

  if (!isInitialized || showOnboarding === null) {
    return (
      <div className="min-h-screen bg-near-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-brand-primary border-t-transparent" />
      </div>
    );
  }

  if (showOnboarding) {
    return (
      <div className="min-h-screen bg-near-white">
        <OnboardingFlow onComplete={handleOnboardingComplete} />
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/transacciones" element={<TransactionsPage />} />
        <Route path="/importar" element={<ImportPage />} />
        <Route path="/presupuesto" element={<BudgetPage />} />
        <Route path="/reportes" element={<ReportesPage />} />
        <Route path="/charts" element={<ChartDemoPage />} />
        <Route path="/ajustes" element={<SettingsPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
